import clamp from 'clamp-js';
import { ready } from './modules/on_ready';

ready(() => {
  function cutDescription() {
    document.body.querySelectorAll('.common-ad-card .specification-section:last-child').forEach((el) => {
      const prevElementsHeiht = $(el).prevAll().toArray().map(element => element.offsetHeight)
        .reduce((a, b) => a + b, 0);
      const description = el.querySelector('.sort-partners-description');

      if (description) {
        clamp(description, {
          clamp: `${el.parentNode.offsetHeight - prevElementsHeiht - 40}px`,
        });
      }
    });
  }

  cutDescription();

  // init clamp.js after reset button
  $('.ads-part-card').on('DOMSubtreeModified', () => {
    cutDescription();
  }, false);
});



// WEBPACK FOOTER //
// ./app/webpacker/src/js/partners.js